import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ContactForm from '../../components/LandingPage/ContactForm/ContactForm';
import Footer from '../../components/LandingPage/Footer/Footer';

export default function FAQ() {
  const [openQuestion, setOpenQuestion] = useState<number | null>(null);
  const { t } = useTranslation();

  // 📌 Obtenemos las FAQs del archivo de traducción
  const faqs = t('faq.items', { returnObjects: true }) as { question: string; answer: string }[];

  const toggleQuestion = (index: number) => {
    setOpenQuestion(openQuestion === index ? null : index);
  };

  // 📌 Scroll al inicio al montar el componente
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-b from-black via-[#0A192F] to-[#060D1B] text-white">
      <div className="container mx-auto px-6 py-24 max-w-6xl">
        
        {/* 🔹 Título principal */}
        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-10 mt-14">
          {t('faq.title')}
        </h1>

        {/* 📌 Texto de introducción */}
        <div className="mb-12 max-w-3xl mx-auto text-center">
          <p className="text-lg md:text-xl text-gray-300 mb-4">{t('faq.intro')}</p>
          <p className="text-lg md:text-xl text-gray-300">{t('faq.contact_prompt')}</p>
        </div>

        {/* 📌 Botones rápidos (FAQ mejorados) */}
        <div className="flex flex-wrap gap-3 justify-center mb-12">
          {faqs?.map((faq, index) => (
            <button
              key={index}
              onClick={() => {
                toggleQuestion(index);
                const element = document.getElementById(`faq-${index}`);
                element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }}
              className="text-md font-semibold text-white px-5 py-3 rounded-lg border border-gray-600 
                         bg-[#18293A] hover:bg-[#243447] transition-all shadow-md hover:shadow-lg"
            >
              {faq.question}
            </button>
          ))}
        </div>

        {/* 📌 FAQ - Acordeón mejorado */}
        <div className="space-y-5 mb-32">
          {faqs?.map((faq, index) => (
            <div
              key={index}
              id={`faq-${index}`}
              className="bg-[#1E293B] rounded-lg shadow-lg border border-gray-700"
            >
              {/* Encabezado de la pregunta */}
              <button
                onClick={() => toggleQuestion(index)}
                className="w-full px-8 py-5 text-left flex items-center justify-between 
                           hover:bg-[#243447] transition-all text-lg font-semibold"
              >
                <span>{faq.question}</span>
                {openQuestion === index ? (
                  <ChevronUp className="h-6 w-6 text-blue-400" />
                ) : (
                  <ChevronDown className="h-6 w-6 text-gray-400" />
                )}
              </button>

              {/* Contenido desplegable con más espacio */}
              <div className={`px-8 transition-all ${openQuestion === index ? 'pb-6 pt-2 block' : 'hidden'}`}>
                <p className="text-gray-300 text-md leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 📌 Formulario de Contacto más ancho y sin fondo extra */}
        <h2 className="text-2xl font-bold text-center mb-4">{t('home.request_registration')}</h2>
        <p className="text-lg text-gray-300 text-center mb-6 max-w-2xl mx-auto">{t('home.contact_subtitle')}</p>
        <div className="max-w-6xl mx-auto">
          <ContactForm className="w-full" hideFAQLink={true} />
        </div>
      </div>

      <Footer/>
    </main>
  );
}
